module.exports = __webpack_public_path__ + "img/title-logo.0c9d0cf3.png";